import apiClient from "@/api/client";
import { saveBlobResponse } from "@/utils/download";

/** „Pobierz zaznaczone (.xlsx)" z listy Podwykonawcy — id w kolejności z ekranu. */
export async function downloadContractorsXlsx(ids: string[]): Promise<void> {
  const resp = await apiClient.post("/contractors/export-xlsx/", { ids }, { responseType: "blob" });
  saveBlobResponse(resp, "Podwykonawcy.xlsx");
}
